import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrow = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 8,
	height: 14,
	viewBox: "0 0 8 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_7_202)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M8.74224e-07 12L5 7L0 2L1 0L8 7L1 14L8.74224e-07 12Z",
				fill: "currentColor"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_7_202",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 8,
				height: 14,
				fill: "currentColor"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgArrow);
export { ForwardRef as ReactComponent };
